import getHashedUrl from '../getHashedUrl';

export class ImageUrlValueConverter {
    toView(value) {
        return getHashedUrl(value);
    }
}
